<template>
  <div>
    <el-dialog title="快速报名" :visible.sync="tshowDailog" :before-close="handleClose">
      <el-form :model="form2">
        <el-form-item label="联系人" :label-width="formLabelWidth">
          <el-input v-model="form2.contacts" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form2.mobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-input type="textarea" :rows="9" placeholder="请输入内容" v-model="form2.content">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tshowDailog = false">取 消</el-button>
        <el-button @click="singup()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    Dialog,
    Button,
    Select,
    Option,
    Form,
    FormItem,
    Input,
    Popconfirm
  } from 'element-ui'
  import {
    projectSingup
  } from '@/api/project.js'
  import {
    getCacheUserInfo
  } from '@/utils/auth';
  export default {
    name: 'ProjectSigup',
    props: {
      showDailog: Boolean,
      pid: Number
    },
    components: {
      [Dialog.name]: Dialog,
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Input.name]: Input,
      [Popconfirm.name]: Popconfirm,
    },
    data() {
      return {
        form2: {
          mobile: '',
          contacts: '',
          content: '',

        },
        formLabelWidth: '80px',
        tshowDailog: this.showDailog,
      }
    },
    watch: {
      showDailog(n,o){
        console.log(n, o)
        this.tshowDailog = n
      }
    },
    mounted() {

    },
    methods: {
      handleClose(){
        this.tshowDailog = false
        this.emitData()
      },
      singup() {
        let userinfo = getCacheUserInfo()
        let params = {
          pid: this.pid ,//账号id
          uid: userinfo.uid, //用户id
          contacts: this.form2.contacts, //联系人
          mobile: this.form2.mobile, //手机号
          content: this.form2.content, //留言内容
        }

        this.$http.post(projectSingup(),
          params
        ).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success("报名成功");
            this.tshowDailog = false
            this.emitData()
          }else{
            this.pid=0 ,//账号id
            this.form2.contacts='', //联系人
            this.form2.mobile='', //手机号
            this.form2.content='', //留言内容
            this.$message.error(res.msg)
            this.tshowDailog = false
            this.emitData()
          }
        });
      },
      emitData() {
        this.$emit('dataChange', {
          show: this.tshowDailog,
        })
      }
    },
  }
</script>

<style>
</style>
